var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-bar-item",class:{active: _vm.isActive},style:({background: !_vm.isActive ? _vm.stepBarInfo().backgroundColor : undefined, color: !_vm.isActive ? _vm.stepBarInfo().textColor : undefined}),on:{"click":_vm.onItemClick}},[(_vm.icon)?_c('i',{class:_vm.icon,staticStyle:{"margin-right":"3px"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }